import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import zoomInIcon from "../../assets/icons/add.png";
import zoomOutIcon from "../../assets/icons/minus.png";
import zoomRefreshIcon from "../../assets/icons/refresh.png";
import { indoorMapZoomScale } from "../../util/helper/constants";
import { handleScrollZoom } from "../../util/helper/helperFunctions";

const ZoomControls = ({
  mapObject,
  zoomLevel,
  setZoomLevel,
  centerMapView
}) => {
  const { results: filterResults } = useSelector((state) => state.inventory);
  const accumulatedDeltaRef = useRef(0);

  useEffect(() => {
    if (!mapObject) return;

    const mapContainer = document.getElementById("indoor-map-id-reference");
    if (indoorMapZoomScale[zoomLevel]) {
      mapContainer.style.transform = indoorMapZoomScale[zoomLevel];
    }
  }, [zoomLevel]);

  useEffect(() => {
    mapObject && mapObject.map.target.doubleClickZoom.disable();
    mapObject && mapObject.map.target.scrollWheelZoom.disable();
    if (mapObject) {
      // centerMapView();
      const mapContainer = document.getElementById("indoor-map-id-reference");
      mapContainer.addEventListener(
        "wheel",
        (event) =>
          handleScrollZoom({
            event,
            accumulatedDeltaRef,
            zoomScales: indoorMapZoomScale,
            setZoomLevel
          }),
        { passive: false }
      );
      return () => {
        mapContainer.removeEventListener("wheel", (event) =>
          handleScrollZoom({
            event,
            accumulatedDeltaRef,
            zoomScales: indoorMapZoomScale,
            setZoomLevel
          })
        );
      };
    }
  }, [mapObject]);

  const resetZoom = () => {
    document.getElementById("indoor-map-id-reference").style.transform =
      "scale(1)";
    setZoomLevel(0);
    centerMapView();
  };

  //resetting scroll zoom and wheelzoom on filter cleared
  useEffect(() => {
    if (filterResults.length === 0) {
      resetZoom();
    }
  }, [filterResults]);

  return (
    <div className="zoom-control-center">
      <button
        id="map-zoom-in-btn"
        className="zoom-controls zoom-in-control"
        disabled={zoomLevel >= indoorMapZoomScale.length - 1}
        onClick={() => setZoomLevel((curr) => ++curr)}
      >
        <img
          alt="zoom-in-icon"
          src={zoomInIcon}
          style={{
            opacity: zoomLevel >= indoorMapZoomScale.length - 1 ? "0.5" : "1"
          }}
        />
      </button>
      <button
        id="map-zoom-out-btn"
        className="zoom-controls zoom-out-control"
        disabled={zoomLevel < 1}
        onClick={() => setZoomLevel((curr) => --curr)}
      >
        <img
          alt="zoom-out-icon"
          style={{ opacity: zoomLevel < 1 ? "0.5" : "1" }}
          src={zoomOutIcon}
        />
      </button>
      <button
        className="zoom-controls zoom-reset-controls"
        disabled={zoomLevel === 0}
        onClick={() => resetZoom()}
      >
        <img
          alt="zoom-refresh-icon"
          style={{ opacity: zoomLevel === 0 ? "0.5" : "1" }}
          src={zoomRefreshIcon}
        />
      </button>
    </div>
  );
};

export default ZoomControls;
